import { render, staticRenderFns } from "./takePhoto.vue?vue&type=template&id=76e860cb&scoped=true&"
import script from "./takePhoto.vue?vue&type=script&lang=js&"
export * from "./takePhoto.vue?vue&type=script&lang=js&"
import style0 from "./takePhoto.vue?vue&type=style&index=0&id=76e860cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e860cb",
  null
  
)

export default component.exports